import { Alert } from 'reactstrap';
import { BiCopyAlt } from 'react-icons/bi';
import { formatDate, formatCurrency } from '../../utils/formatters';

// Pre-save warning shown in the expense/invoice create + edit modals when the
// server's CheckDuplicates returns one or more likely duplicates. Purely
// advisory — the caller keeps a "Save anyway" button so it never blocks the
// commit. `matches` are DuplicateMatchViewModel rows from the API.
export default function DuplicateWarning({ matches, currency = 'GBP' }) {
    if (!matches || matches.length === 0) return null;
    return (
        <Alert color="warning" className="d-flex align-items-start gap-2 py-2 small mb-2">
            <BiCopyAlt className="mt-1 flex-shrink-0" size={18} />
            <div>
                <div className="fw-semibold mb-1">
                    {matches.length === 1 ? 'This looks like a possible duplicate.' : 'This looks like a possible duplicate.'}
                </div>
                <ul className="mb-1 ps-3">
                    {matches.map((m) => (
                        <li key={m.id}>
                            {[m.vendor, formatCurrency(m.amount, currency), formatDate(m.date)]
                                .filter(Boolean)
                                .join(' · ')}
                            {m.jobNumber ? ` — job ${m.jobNumber}` : ''}
                        </li>
                    ))}
                </ul>
                <div className="text-muted">Save anyway if this is a separate entry.</div>
            </div>
        </Alert>
    );
}
